/*
  Dropdown order for the Device option, generated by build/write_device_order.py from
  build/plan.json. Do not hand-edit: change build/devices.csv, re-run `generate_plan.py plan`
  and then this script.

  It exists because Shopify owns the stored order of option values and appends new ones to
  the end, so the brand grouping in the dropdown cannot come from the product itself.
  assets/pp-device-picker.js sorts the options by this list and rebuilds the <optgroup>s.
  Anything not listed here still shows, sorted by name, after everything that is.
*/
window.PP_DEVICE_ORDER = [
  "Google Pixel 11 Pro XL",
  "Google Pixel 11 Pro Fold",
  "Google Pixel 11 Pro",
  "Google Pixel 11",
  "Google Pixel 10a",
  "Google Pixel 10 Pro XL",
  "Google Pixel 10 Pro Fold",
  "Google Pixel 10 Pro",
  "Google Pixel 10",
  "Google Pixel 9a",
  "Google Pixel 9 Pro XL",
  "Google Pixel 9 Pro Fold",
  "Google Pixel 9 Pro",
  "Google Pixel 9",
  "Google Pixel 8a",
  "Google Pixel Tablet",
  "Google Pixel Fold",
  "Google Pixel 8 Pro",
  "Google Pixel 8",
  "Google Pixel 7a",
  "Google Pixel 7 Pro",
  "Google Pixel 7",
  "Google Pixel 6a",
  "Google Pixel 6 Pro",
  "Google Pixel 6",
  "Google Pixel 5a (5G)",
  "Google Pixel 5",
  "Google Pixel 4a (5G)",
  "Google Pixel 4a",
  "Google Chromecast with Google TV (4K)",
  "Google Pixel 4 XL",
  "Google Pixel 4",
  "Google Pixel 3a XL",
  "Google Pixel 3a",
  "Google Pixel 3 XL",
  "Google Pixel 3",
  "Google Pixel 2 XL",
  "Google Pixel 2",
  "Google Pixel XL",
  "Google Pixel",
  "Apple iPhone 15 Pro Max",
  "Apple iPhone 15 Pro",
  "Apple iPhone 15 Plus",
  "Apple iPhone 15",
  "Apple iPhone SE (3rd generation)",
  "Apple iPhone 14 Pro Max",
  "Apple iPhone 14 Pro",
  "Apple iPhone 14 Plus",
  "Apple iPhone 14",
  "Apple iPhone 13 Pro Max",
  "Apple iPhone 13 Pro",
  "Apple iPhone 13 mini",
  "Apple iPhone 13",
  "Apple iPhone SE (2nd generation)",
  "Apple iPhone 12 Pro Max",
  "Apple iPhone 12 Pro",
  "Apple iPhone 12 mini",
  "Apple iPhone 12",
  "Apple iPhone 11 Pro Max",
  "Apple iPhone 11 Pro",
  "Apple iPhone 11",
  "Apple iPhone XS Max",
  "Apple iPhone XS",
  "Apple iPhone XR",
  "Apple iPhone X",
  "Apple iPhone 8 Plus",
  "Apple iPhone 8",
  "Apple iPhone SE (1st generation)",
  "Apple iPhone 7 Plus",
  "Apple iPhone 7",
  "Apple iPhone 6s Plus",
  "Apple iPhone 6s",
  "Samsung Galaxy A73 5G",
  "Samsung Galaxy Z Fold3",
  "Samsung Galaxy Z Flip3",
  "Samsung Galaxy S21+",
  "Samsung Galaxy S21 Ultra",
  "Samsung Galaxy S21",
  "Samsung Galaxy S20 FE (Snapdragon)",
  "Samsung Galaxy M52 5G",
  "Samsung Galaxy F62 / M62",
  "Samsung Galaxy A72",
  "Samsung Galaxy A52s 5G",
  "Samsung Galaxy A52 5G",
  "Samsung Galaxy A52 4G",
  "Samsung Galaxy A52",
  "Samsung Galaxy Z Fold2",
  "Samsung Galaxy Z Flip 5G",
  "Samsung Galaxy Z Flip",
  "Samsung Galaxy Tab S7+",
  "Samsung Galaxy Tab S7 (Wi-Fi)",
  "Samsung Galaxy Tab S7 (LTE)",
  "Samsung Galaxy Tab S7",
  "Samsung Galaxy Tab S6 Lite (Wi-Fi)",
  "Samsung Galaxy Tab S6 Lite (LTE)",
  "Samsung Galaxy Tab S6 Lite (2020 / 2022)",
  "Samsung Galaxy Tab A7 10.4 2020 (Wi-Fi)",
  "Samsung Galaxy Tab A7 10.4 2020 (LTE)",
  "Samsung Galaxy S20+ (4G / 5G)",
  "Samsung Galaxy S20+",
  "Samsung Galaxy S20 Ultra (5G)",
  "Samsung Galaxy S20 Ultra",
  "Samsung Galaxy S20 FE (Exynos)",
  "Samsung Galaxy S20 FE",
  "Samsung Galaxy S20 (4G / 5G)",
  "Samsung Galaxy S20",
  "Samsung Galaxy Note20 Ultra (4G / 5G)",
  "Samsung Galaxy Note20 Ultra",
  "Samsung Galaxy Note20",
  "Samsung Galaxy M31",
  "Samsung Galaxy A71",
  "Samsung Galaxy A21s",
  "Samsung Galaxy Tab S5e (Wi-Fi)",
  "Samsung Galaxy Tab S5e (LTE)",
  "Samsung Galaxy Tab A 8.0 2019 (Wi-Fi)",
  "Samsung Galaxy S10e",
  "Samsung Galaxy S10+",
  "Samsung Galaxy S10 5G",
  "Samsung Galaxy S10",
  "Samsung Galaxy Note10+ 5G",
  "Samsung Galaxy Note10+",
  "Samsung Galaxy Note10 5G",
  "Samsung Galaxy Note10",
  "Samsung Galaxy Fold",
  "Samsung Galaxy A51",
  "Samsung Galaxy A50",
  "Samsung Galaxy S9+",
  "Samsung Galaxy S9",
  "Samsung Galaxy Note9",
  "OnePlus Pad 4",
  "OnePlus Nord CE 6 Lite",
  "OnePlus Nord CE 6",
  "OnePlus Nord 6",
  "OnePlus 15T",
  "OnePlus Pad Lite",
  "OnePlus Pad Go 2",
  "OnePlus Pad 3",
  "OnePlus Pad 2 Pro / Pad 3",
  "OnePlus Nord CE 5",
  "OnePlus Nord 5",
  "OnePlus 15R",
  "OnePlus 15",
  "OnePlus 13T",
  "OnePlus 13s",
  "OnePlus 13R",
  "OnePlus 13",
  "OnePlus Pad Pro / Pad 2",
  "OnePlus Pad 2",
  "OnePlus Nord N30 SE 5G",
  "OnePlus Nord CE 4 Lite 5G",
  "OnePlus Nord CE 4",
  "OnePlus Nord 4",
  "OnePlus Ace 5",
  "OnePlus Ace 3V",
  "OnePlus Ace 3 Pro",
  "OnePlus Ace 3",
  "OnePlus 12R",
  "OnePlus Pad Go",
  "OnePlus Pad",
  "OnePlus Open",
  "OnePlus Nord N30 5G",
  "OnePlus Nord CE 3 Lite 5G / Nord N30 5G",
  "OnePlus Nord CE 3 Lite 5G",
  "OnePlus Nord CE 3 5G",
  "OnePlus Nord 3 5G",
  "OnePlus 12",
  "OnePlus 11R",
  "OnePlus 11",
  "OnePlus Nord N300 5G",
  "OnePlus Nord N20 SE",
  "OnePlus Nord N20 5G",
  "OnePlus Nord CE 2 Lite 5G",
  "OnePlus Nord CE 2 5G",
  "OnePlus Nord 2T 5G",
  "OnePlus 10T",
  "OnePlus 10R",
  "OnePlus 10 Pro",
  "OnePlus Nord N200 5G",
  "OnePlus Nord N200",
  "OnePlus Nord CE 5G",
  "OnePlus Nord 2 5G",
  "OnePlus 9RT",
  "OnePlus 9R",
  "OnePlus 9 Pro",
  "OnePlus 9",
  "OnePlus Nord N100",
  "OnePlus Nord N10 5G",
  "OnePlus Nord",
  "OnePlus 8T",
  "OnePlus 8 Pro",
  "OnePlus 8",
  "OnePlus 7T Pro",
  "OnePlus 7T",
  "OnePlus 7 Pro",
  "OnePlus 7",
  "OnePlus 6T",
  "OnePlus 6",
  "OnePlus 5T",
  "OnePlus 5",
  "Fairphone (Gen. 6)",
  "Fairphone 5",
  "Fairphone 4",
  "Fairphone 3 / 3+",
  "Motorola Moto G 5G (2024)",
  "Motorola Moto G45 5G",
  "Motorola Moto G15 / Moto G15 Power / Moto G05",
  "Motorola Edge 2024",
  "Motorola ThinkPhone",
  "Motorola Moto G Stylus 5G (2023)",
  "Motorola Moto G84 5G",
  "Motorola Moto G34 5G / Moto G45 5G",
  "Motorola Moto G34 5G",
  "Motorola Edge 40 Pro / Moto X40 / Edge+ (2023)",
  "Motorola Edge 40 Neo",
  "Motorola Moto G Stylus 5G (2022)",
  "Motorola Moto G82 5G",
  "Motorola Moto G52",
  "Motorola Moto G42",
  "Motorola Moto G32",
  "Motorola Edge 30 Ultra",
  "Motorola Edge 30 Neo",
  "Motorola Edge 30 Fusion / Moto S30 Pro",
  "Motorola Edge 30",
  "Motorola Moto G Stylus 5G",
  "Motorola Moto G Power 2021",
  "Motorola Moto G200 5G / Edge S30",
  "Motorola Moto G50",
  "Motorola Moto G30 / Lenovo K13 Pro",
  "Motorola Moto G10 / Moto G10 Power / Lenovo K13 Note",
  "Motorola Edge S / Moto G100",
  "Motorola Edge 2021",
  "Motorola Edge 20 Pro",
  "Motorola Edge 20",
  "Motorola Defy 2021",
  "Motorola Moto G 5G Plus",
  "Motorola Moto G 5G",
  "Motorola Moto G9 Power / Lenovo K12 Pro",
  "Motorola Moto G9 / G9 Play / Lenovo K12 Note",
  "Motorola Moto E7 Plus / Lenovo K12",
  "Motorola Edge",
  "Motorola One Vision / P50",
  "Motorola One Action",
  "Motorola Moto G7 Power",
  "Motorola Moto G7 Plus",
  "Motorola Moto G7 Play",
  "Motorola Moto G7",
  "Motorola Moto Z3 Play",
  "Motorola Moto Z3",
  "Motorola Moto G6 Plus",
  "Motorola Moto Z2 Force / Moto Z (2018)",
  "Motorola Moto X4",
  "Sony Xperia 10 VII",
  "Sony Xperia 1 VI",
  "Sony Xperia 10 V",
  "Sony Xperia 5 V",
  "Sony Xperia 1 V",
  "Sony Xperia 10 IV",
  "Sony Xperia 5 IV",
  "Sony Xperia 1 IV",
  "Sony Xperia 5 III",
  "Sony Xperia 1 III",
  "Sony Xperia 5 II",
  "Sony Xperia 1 II",
  "Sony Xperia 10 Plus",
  "Sony Xperia 10",
  "Sony Xperia XZ3",
  "Sony Xperia XZ2 Premium",
  "Sony Xperia XZ2 Compact",
  "Sony Xperia XZ2",
  "Sony Xperia XA2 Ultra",
  "Sony Xperia XA2 Plus",
  "Sony Xperia XA2",
  "Nothing Phone (2)",
  "Nothing Phone (1)",
  "LG Velvet",
  "LG V60 ThinQ",
  "LG Style3",
  "LG V40 ThinQ",
  "LG V35 ThinQ",
  "LG G7 ThinQ (G710ULM / VMX)",
  "LG G7 ThinQ (G710N)",
  "LG G7 ThinQ (G710AWM / EM / EMW) / G7+ ThinQ",
  "LG V30 (Unlocked / T-Mobile / Other)",
  "LG V30 (Japan)",
  "LG G6 (US Unlocked)",
  "LG G6 (T-Mobile)",
  "LG G6 (EU Unlocked)",
  "LG G6 (EU Unlocked - ENG BL)",
  "LG G6 (Canada - ENG BL)",
  "LG V20 (VZW)",
  "LG V20 (TMO)",
  "LG V20 (Sprint)",
  "LG V20 (GSM Unlocked)",
  "LG V20 (GSM Unlocked - DirtySanta)",
  "LG V20 (Global)",
  "LG V20 (AT&T)",
  "LG G5 (US)",
  "LG G5 (TMO)",
  "LG G5 (Intl)",
  "Nokia 7 plus",
  "Nokia 6.1 (2018)",
  "Nokia 8",
  "ASUS ZenFone 8",
  "ASUS Zenfone 5Z (ZS620KL)",
  "Realme GT Neo6",
  "Realme 10 Pro 5G",
  "Realme 9 Pro 5G / 9 5G / Q5",
  "Razer Edge WiFi / 5G",
  "Razer Phone 2",
  "Razer Phone",
  "Nubia Red Magic 5G / 5S",
  "Nubia Mini 5G",
  "Nubia Z18",
  "Nubia X",
  "Nubia Red Magic Mars",
  "Nubia Z17",
  "F(x)tec Pro1 X",
  "F(x)tec Pro1",
  "Essential PH-1",
  "OSOM OV1",
  "Lenovo Z6 Pro",
  "Lenovo Z5 Pro GT",
  "NVIDIA Shield TV (2019)",
  "NVIDIA Jetson (Nano / Nano 2GB)",
  "NVIDIA Jetson (TX2 / TX2 NX)",
  "NVIDIA Shield TV (2015 / 2015 Pro / 2017 / 2019 Pro) / Jetson TX1",
  "Nintendo Switch v1 / v2 / Lite / OLED",
  "Retroid Pocket Nova",
  "Retroid Pocket 6",
  "AYN Odin2 Portal",
  "AYN Odin 2",
  "AYN Odin (M2)",
  "AYN Odin (M0)",
  "Radxa Zero 2 (S905D3, eMMC Only)",
  "Radxa Zero (S905Y2, eMMC Only)",
  "HardKernel ODROID-C4 (S905X3, eMMC Only)",
  "Banana Pi M5 (S905X3, eMMC Only)",
  "Freebox Pop / TV (Realtek Wi-Fi / Bluetooth)",
  "Freebox Pop / TV (Broadcom Wi-Fi / Bluetooth)",
  "Dynalink TV Box 4K (2021)",
  "Walmart onn. TV Box 4K (2021)",
  "Zinwa Q25 Pro",
  "Solana Saga",
  "Smartisan R1",
  "Vsmart Joy 3 / Joy 3+",
  "ZTE Axon 9 Pro",
  "SHIFT6mq",
  "SHIFTphone 8.0 / 8.1",
  "Any supported device"
];
